import { render, staticRenderFns } from "./flexible.vue?vue&type=template&id=6efa2ad1&scoped=true&"
import script from "./flexible.vue?vue&type=script&lang=js&"
export * from "./flexible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa2ad1",
  null
  
)

export default component.exports